<template>
  <div>
    <!-- <div style="margin-bottom: 10px;" ref="drawer">
      方程应用于所有原料： <equation :equationId="allEquationId" @equationChange="allEquationChange" :propEquationList='equationList'/>
    </div> -->
      <a-table
        :columns="columns"
        :data-source="list"
        row-key="id"
        :scroll="{y,x: 500}"
        :pagination="false"
        bordered
        class="textLeft"
      >
      
        <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 原料名称</span>
        <template slot="name" slot-scope="text, record">
          <a-tooltip v-if="record.equationId">
            <template slot="title">
              {{overseasFlag == '1' ? (record.aliasName || text) : text}} - 查看差异
            </template>
            <a @click="showMaterial(record)"  class="nameStyle">{{overseasFlag == '1' ? (record.aliasName || text) : text}}</a>
          </a-tooltip>
          <a-tooltip v-else>
            <template slot="title">
              {{overseasFlag == '1' ? (record.aliasName || text) : text}}
            </template>
            <span>{{overseasFlag == '1' ? (record.aliasName || text) : text}}</span>
          </a-tooltip>
        </template>
        <template slot="equationId" slot-scope="text, record,ind">
          <equation v-if="record.isFucCal == 1" :equationId="record.equationId || undefined" :ind="ind" @equationChange="equationChange" :propEquationList='equationList'/>
        </template>
        <template
          v-for="col in codeArr"
          :slot="col"
          slot-scope="text, record"
        >
          <cell-editor :len="4" :item="record" :key="col" :name="col" @blur="target => itemUpdate(target,record.id)" :text="text" :actions="e => update(e,col)" :background="true" :precision="4"/>
        </template>
      </a-table>
      <material-modal ref="MaterialModal" :rawId="rawId" :equationId='equationId' :rawName='rawName' :selectedRows="selectedList" :rawObj="rawObj" />
      <div class="footer" style="border-top: 1px solid #e5e5e5;padding-top: 15px;">
        <div style="margin: 0 0 0 24px;float: left;" ref="drawer">
          方程应用于所有原料： <equation :equationId="allEquationId" @equationChange="allEquationChange" :propEquationList='equationList'/>
        </div>
        <div style="height: 25px;float: right;" >
          <a-button @click="pre" style="margin-left: 20px;">上一步</a-button>
          <a-button @click="calculation" type="primary" style="float: right;">计算并保存</a-button>
        </div>
      </div>
      <a-modal :visible="showProgress" @cancel="clearMessage" :footer='false' :closable='showFooter' :maskClosable="false">
        <!-- title="正在计算并保存" -->
        <h3 style="font-weight: bold;color:#333;margin-bottom: 15px;">正在计算并保存</h3>
        <a-progress :percent="progress" :status="progressStatus" :showInfo="false" :height='20'/>
        <div v-if="successNum <= marterArr.length">
          {{marterArr[successNum].name}}正在处理中，已完成{{progress}}%
        </div>
      </a-modal>
  </div>
</template>

<script>
import Equation from './Equation.vue'
import { mapState,mapMutations } from 'vuex'
import CellEditor from '../CommonConponents/CellEditor.vue'
import MaterialModal from './MaterialModal.vue'
export default {
  components:{Equation,CellEditor,MaterialModal},
  data(){
    return {
      y: 300,
      equationList:[],
      columns: [],
      list:[],
      filled: true,
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      allEquationId: undefined,
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      rawId: '',
      equationId: undefined,
      rawName: '',
      rawObj: {},
      successNum: 0,
      progressStatus: 'active',
      showProgress:false,
      showFooter:false,
    }
  },
  mounted(){
    this.getList()
    this.columns = this.getColumns()
    let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
    this.y = clientHeight - 160 - (this.$refs.drawer.clientHeight || 0)
  },
  computed:{
    ...mapState('material',['codeArr','selectedList','marterArr','selectedRowKeys']),
    progress(){
      let num = 0
      if(this.marterArr.length > 0) num = parseInt(this.successNum / this.marterArr.length * 100)
      return num
    },
  },
  watch:{
    // codeArr:{
    //   handler(){
    //     this.getList()
    //     this.columns = this.getColumns()
    //   },
    //   deep: true
    // },
    filled(){
      this.columns = this.getColumns()
    }
  },
  methods:{
    ...mapMutations('material',['setState']),
    clearMessage(){
      this.showProgress = false
      this.showFooter = false
      this.successNum = 0
      this.progressStatus = 'active'
    },
    pre(){
      this.list = []
      this.setState({steps: 0})
    },
    allEquationChange(data){
      this.allEquationId = data.val || undefined
      this.list.map(el => {
        if(el.isFucCal == 1){
          el.equationId = data.val || ''
        }
        return el
      })
    },
    fixedCol(e){
      this.filled = !this.filled
      // this.changeColumns2()
      e = e || window.event; 
      if(e.stopPropagation) { //W3C阻止冒泡方法  
          e.stopPropagation();  
      } else {  
          e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    showMaterial(record){
      this.rawId = record.rawId
      this.equationId = record.equationId
      this.rawName = this.overseasFlag == 1 ? (record.aliasName || record.name) : record.name
      this.rawObj = record
      setTimeout(() => {
        this.$refs.MaterialModal.init()
      }, 0);
    },
    equationChange(data){
      this.list[data.ind]['equationId'] = data.val || ''
    },
    itemUpdate(item,id){
      const newData = [...this.list]
      const targets = newData.filter(item => id === item.id)[0]
      item.isUpdate = true
      if (targets) {
        Object.assign(targets, item,{
          name: targets.name,
          aliasName: targets.aliasName
        })
        this.list = newData
      }
    },
    async update(arg,feild){
      if(feild === 'C001'){
        if(arg.C001 || arg.C001 === 0){
          arg.C097 = 100 - arg.C001
        }else{
          arg.C097 = arg['C097BaseNutritionVal']
          arg.C001 = arg['C001BaseNutritionVal']
        }
        arg['C097Flag'] = true
      }else if(feild === 'C097'){
        if(arg.C097 || arg.C097 === 0){
          arg.C001 = 100 - arg.C097
        }else{
          arg.C097 = arg['C097BaseNutritionVal']
          arg.C001 = arg['C001BaseNutritionVal']
        }
        arg['C001Flag'] = true
      }else{
        if(!arg[feild] && arg[feild] !== 0){
          arg[feild] = arg[feild + 'BaseNutritionVal']
        }
      }
      arg[feild + 'Flag'] = true
    },
    calculation(){
      this.$confirm({
        icon: ' ',
        title: '计算并保存结果',
        // content: <p><span style="color: red;">我们将根据您修改的指标数值批量计算并保存到原料中</span>，你还要继续吗？</p>,
        content: <p style={{'margin-left': '-38px',color: '#333'}}>我们将根据您修改的指标数值批量计算并保存到原料中，你还要继续吗？</p>,
        cancelText:'取消',
        okText:'继续',
        onOk: ()=> {
          if(this.list.length === 0) return
          this.materialIndex = 0
          this.showProgress = true
          this.successNum = 0
          this.showFooter = false
          this.progressStatus = 'active'
          this.timeInter = setInterval(() => {
            this.calculationData(this.list[this.materialIndex])
          }, 0);
        }
      })
    },
    calculationData(record){
      if(!record) return
      if(this.materialIndex === this.list.length - 1) {
        clearInterval(this.timeInter)
      }
      if(this.materialIndex < (this.list.length - 1)) this.materialIndex += 1
      let data = {}
      let nutritionValues = []
      this.selectedList.forEach(item => {
        nutritionValues.push({
          "code": item.code,
          "id": record[item.code + 'rowId'],
          "nutritionId": record[item.code + 'nutritionId'],
          "nutritionValue": record[item.code],
          "rawId": record[item.code + 'rawId'],
          "typeId": record[item.code + 'typeId'],
        })
      })
      let rawNutritionCalculatList = [
        {
          equationId: record.equationId,
          factoryId: window.localStorage.getItem('factoryId'),
          rawId: record.rawId,
          nutritionValues
        }
      ]
      data = {
        factoryId: window.localStorage.getItem('factoryId'),
        rawNutritionCalculatList,
      }
      let url = '/nhf-app//factorystaffnutritionraw/rawEquationCalculateDirectSaveWithMultiRaw'
      if(record.equationId) url = '/nhf-app/factorystaffnutritionraw/rawEquationCalculateBackGroundWithMultiRaw'
      
      this.$post(url,data).then(res => {
        let {success} = res || {}
        if(success) {
          this.successNum += 1
          if(this.successNum === this.list.length){
            // this.$message.success('计算保存成功')
            setTimeout(() => {
              this.showProgress = false
              this.$success({
                title: '数据保存成功',
                content: '已完成多原料修改！',
                okText: '确定',
                onOk: () => {
                  this.setState({steps: 0,codeArr:[],selectedList:[],selectedRowKeys:[],marterArr:[],visible: false})
                }
              });
            }, 1000);
          }
        }else{
          // this.$message.error('计算保存失败')
          this.progressStatus = 'exception'
          this.showFooter = true
          this.$confirm({
            icon: () => <a-icon type="close-circle" />,
            title: '数据保存失败',
            content: '请检查方程或者指标数值是否正确设置！',
            okText: '继续',
            cancelText: '取消',
            onOk: () => {
              
            },
            onCancel: () => {
              this.visible = false
              this.visible2 = false
            }
          });
        }
      }).catch(() => {
          this.$confirm({
            icon: () => <a-icon type="close-circle" />,
            title: '数据保存失败',
            content: '请检查方程或者指标数值是否正确设置！',
            okText: '继续',
            cancelText: '取消',
            onOk: () => {
              
            },
            onCancel: () => {
              this.visible = false
              this.visible2 = false
            }
          });
        this.progressStatus = 'exception'
        this.showFooter = true
      })
    },
    getList(pagination){
      let {pageSize,current} = pagination || this.pagination
      let rawIds = []
      this.marterArr.forEach(el => {
        rawIds.push(el.rawId)
      })
      let params = {
        size: pageSize,current,
        factoryId: window.localStorage.getItem('factoryId'),
        rawIds:rawIds.join(','),
        nutritionIds: this.selectedRowKeys.join(',')
      }
      this.filled = false
      this.$http.get('/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawsInfoPage',{params}).then(res => {
        let {success,data} = res || {}
        if(success){
          let list = []
          this.marterArr.forEach((el,ind) => {
            let obj = {}
            data[el.rawId] && data[el.rawId].forEach(item => {
              obj[item.code + 'nutritionId'] = item.nutritionId
              obj[item.code] = item.nutritionAnalysisVal
              obj[item.code + 'rawId'] = item.rawId
              obj[item.code + 'rowId'] = item.id
              obj[item.code + 'typeId'] = item.typeId
              obj[item.code + 'Flag'] = false
              obj[item.code + 'BaseNutritionVal'] = item.baseNutritionVal
            })
            list.push({
              id: el.id,
              name: el.name,
              code: el.code,
              rawId: el.rawId,
              isFucCal: el.isFucCal,
              aliasName: el.aliasName,
              equationId: this.list.length > 0 ? this.list[ind].equationId : '',
              ...obj,
            })
          })
            this.list = list || []
          setTimeout(() => {
            this.filled = true
          }, 10);
        }
      })
    },
    getColumns(){
      let arr= [
        {
          // title: '原料名称',
          slots: { title: 'customTitle' },
          dataIndex: 'name',scopedSlots: { customRender: 'name' },width:160,ellipsis: true,},
        {title: '原料代码',dataIndex: 'code',width: 100,},
        {title: '方程体系',dataIndex: 'equationId',scopedSlots: { customRender: 'equationId' },width: 180},
      ]
      if(this.filled){
        arr[0].fixed = 'left'
      }else{
        delete arr[0].fixed
      }
      this.selectedList && this.selectedList.forEach(el => {
        arr.push({
          title: el.name,
          dataIndex: el.code,
          width: 120,
          align: 'center',
          scopedSlots: { customRender: el.code },
        })
      })
      return arr
    },
  }
}
</script>